import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetStoreExpenseDetailsQuery } from '../slices/storeExpensesApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import StoreExpenseCarousel from '../components/StoreExpenseCarousel';

const StoreExpenseStaffScreen = () => {
  const { id: storeExpenseId } = useParams();
  const { data: storeExpense, isLoading, error } = useGetStoreExpenseDetailsQuery(storeExpenseId);

  const renderStoreExpenseDetails = () => (
    <>
      <Meta title={storeExpense.date} description={storeExpense.account} />
      <Row>
        <Col md={6}>
          {/* Display storeExpense images using StoreExpenseCarousel */}
          {storeExpense.images && storeExpense.images.length > 0 ? (
            <StoreExpenseCarousel images={storeExpense.images} />
          ) : (
            <Message variant="info">No images available for this storeExpense</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{storeExpense.accountName}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Details: {storeExpense.details}</ListGroup.Item>
            <ListGroup.Item>Amount: {storeExpense.amount}</ListGroup.Item>
            <ListGroup.Item>
              Category: {storeExpense.category}
            </ListGroup.Item>
            <ListGroup.Item>Notes:{storeExpense.notes}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Amount:</Col>
                  <Col>
                    <strong>{storeExpense.amount}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>User:</Col>
                  <Col>
                    {storeExpense.username}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="storeExpense-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {storeExpense.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to='/storeExpenselist'>
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderStoreExpenseDetails()
      )}
    </>
  );
};

export default StoreExpenseStaffScreen;